/* eslint-disable @typescript-eslint/no-explicit-any */
import {useEffect, useState} from 'react';
import {Platform} from 'react-native';

import {replaceSpecialCharacters} from '../../common/utils/functions';
import {
  defaultAssured,
  defaultErrorAssured,
  defaultErrorValues,
  showErrorAssuredDefault,
  showErrorAssuredSubmit,
  showErrorValuesDefault,
  showErrorValuesSubmit,
} from '../../data/constants/Assurance/AssuranceVoyage/modification';
import {
  IAssured,
  IError,
  IshowErrorValuesDefault,
  IValues,
} from '../../data/types/interface/Assurance/AssuranceVoyage/modification';

export type typeFormInterface = 'renseignement' | 'sante';
export const useForm = (
  data: IValues,
  // eslint-disable-next-line @typescript-eslint/no-unsafe-function-type
  Validate: Function,
  onCancel: () => void,
  handleSave: () => void,
) => {
  console.log(data);

  const [values, setValues] = useState<IValues>(data);
  const [dto, setDto] = useState({error: true, data});
  const [showErrors, setShowErrors] = useState<IshowErrorValuesDefault>({
    ...showErrorValuesDefault,
  });
  const [errors, setErrors] = useState<IError>(defaultErrorValues);

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const handleChange = (name: string, value: any, fired: boolean) => {
    setShowErrors({...showErrors, [name]: value !== fired});
    setValues({...values, [name]: value});
  };

  const noError = (errors: IError) => {
    let bNoError = true;
    const listException: Array<string> = ['id', 'assure'];

    Object.entries(errors).forEach(element => {
      if (element[1] !== '' && !listException.includes(element[0])) {
        bNoError = false;
      }
    });
    errors.assure?.length &&
      errors.assure.map(errorElt => {
        Object.entries(errorElt).forEach(element => {
          if (element[1] !== '' && !listException.includes(element[0])) {
            bNoError = false;
          }
        });
      });

    return bNoError;
  };

  const handleSubmit = () => {
    setShowErrors({
      ...showErrorValuesSubmit,
      assure: values.assure.length
        ? [
            ...values.assure.map(element => ({
              ...showErrorAssuredSubmit,
              id: element.id,
            })),
          ]
        : [],
    });

    const validationErrors = Validate(values);

    setErrors(validationErrors);

    if (noError(validationErrors)) {
      setDto({error: false, data: values});
    } else {
      setDto({error: true, data: data});
    }
  };

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const handleAddAssured = (
    nbrAssured: number,
    initValues: Array<IAssured>,
    otherDatas: IValues,
  ) => {
    const nbr: number = nbrAssured || 1;

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const updateAssuredArray = (prevAssured: any[], defaultAssured: any) => {
      if (Array.isArray(defaultAssured)) {
        if (defaultAssured.length === nbr) {
          //
          return prevAssured.concat(
            initValues.map((currentItem, index: number) => {
              const tmpBlob = new Blob([''], {type: 'image/jpeg'});
              const tmpFile = new File([tmpBlob], `assured_${index}`, {
                type: 'image/jpeg',
              });
              return {
                ...defaultAssured[index],
                id: currentItem.id,
                lastPasseportFile: currentItem.passeportFile,
                passeportFile: [tmpFile],
                newImage: false,
              };
            }),
          );
        } else {
          return [];
        }
      } else {
        return prevAssured.concat(
          initValues.map(currentValue => ({
            ...defaultAssured,
            id: currentValue.id,
          })),
        );
      }
    };

    setValues({
      ...otherDatas,
      assure: updateAssuredArray([], initValues ? initValues : defaultAssured),
    });

    setErrors(prevErrors => ({
      ...prevErrors,
      assure: updateAssuredArray([], defaultErrorAssured),
    }));

    setShowErrors(prevShowErrors => ({
      ...prevShowErrors,
      assure: updateAssuredArray([], showErrorAssuredDefault),
    }));
  };

  const handleInitValues = () => {
    console.log('init');

    data.assure.length &&
      handleAddAssured(data.assure.length, [...data.assure], data);
  };

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const handleChangeAssured = (
    id: string,
    name: string,
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    value: any,
    fired: boolean,
    remove?: boolean,
  ) => {
    setShowErrors(prevErrors => ({
      ...prevErrors,
      assure: [
        ...prevErrors.assure.map(element => {
          if (element.id !== id) {
            return element;
          } else {
            return {
              ...element,
              [name]: value !== fired,
            };
          }
        }),
      ],
    }));

    const listToUpperCase: Array<string> = ['nom', 'prenom'];

    setValues(prevValues => {
      return {
        ...prevValues,
        assure: [
          ...prevValues.assure.map((assureElt: any) => {
            if (assureElt.id !== id) {
              return assureElt;
            } else {
              if (name === 'passeportFile') {
                const _value =
                  Platform.OS !== 'web'
                    ? {
                        uri: value?.file?.uri,
                        type: value?.file?.type,
                        name: value?.file?.fileName,
                      }
                    : value;

                if (remove) {
                  return {
                    ...assureElt,
                    [name]: [],
                  };
                }

                const images = assureElt[name] ? [...assureElt[name]] : [];
                images.push(_value);

                return {
                  ...assureElt,
                  [name]: images,
                  newImage: true,
                };
              } else if (listToUpperCase.includes(name)) {
                return {
                  ...assureElt,
                  [name]:
                    typeof value === 'string'
                      ? replaceSpecialCharacters(value)
                          ?.replace(/[^A-Za-z0-9 ]/g, '')
                          .toUpperCase()
                      : value,
                };
              } else {
                return {
                  ...assureElt,
                  [name]:
                    typeof value === 'string'
                      ? replaceSpecialCharacters(value)
                      : value,
                };
              }
            }
          }),
        ],
      };
    });
  };

  const handleCancel = () => {
    setValues(data);
    onCancel();
  };

  useEffect(() => {
    setErrors(Validate(values));
  }, [values]);

  useEffect(() => {
    console.log(dto.error);

    if (!dto.error) {
      handleSave();
    }
  }, [dto]);

  return {
    handleChange,
    handleSubmit,
    handleCancel,
    values,
    errors,
    showErrors,
    dto,
    handleAddAssured,
    handleChangeAssured,
    handleInitValues,
  };
};
